import {
  GET_LIST_DUNOCHOVAY,
  GET_LIST_DUNOCHOVAY_SUCCESS,
  GET_LIST_DUNOCHOVAY_FAILURE,
  UPDATE_SEARCHTDATA_DUNOCHOVAY,
} from "./actionTypes";

export const getListDuNoChoVay = (dataSearch) => ({
  type: GET_LIST_DUNOCHOVAY,
  dataSearch,
});
export const getListDuNoChoVaySuccess = (data) => ({
  type: GET_LIST_DUNOCHOVAY_SUCCESS,
  payload: data,
});
export const getListDuNoChoVayFailure = (dataSearch) => ({
  type: GET_LIST_DUNOCHOVAY_FAILURE,
});
export const updateDataSearch = (data) => ({
  type: UPDATE_SEARCHTDATA_DUNOCHOVAY,
  payload: data,
});
